import React from "react";
import { FaArrowCircleRight } from "react-icons/fa";
import AboutSection from "../Components/AboutSection";
import { StatsSection } from "./Home";

const About = () => {
  return (
    <>
      <div
        className="h-[20rem] bg-cover relative bg-center flex items-center justify-start text-white"
        style={{
          backgroundImage: 'url("./img/slide2.jpg")',
        }}
      >
         <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <h1 className="text-5xl font-bold text-white absolute top-1/3 left-1/4 sm:top-1/4 sm:left-1/3 md:top-1/4 md:left-1/4 lg:top-40 lg:left-28">
          About Us
        </h1>
      </div>
      <AboutSection />
      {/* <!-- Statistics Section --> */}
          <StatsSection />
      {/* <section class="py-20 bg-gray-100" id="Statistics">
        <div class="container mx-auto px-4">
          <div class="text-center mb-16">
            <h2 class="text-4xl font-bold text-gray-800 mb-4">
              <span class="text-orange-600">Statistics</span>
            </h2>
            <div class="w-16 h-1 bg-orange-600 mx-auto mb-6"></div>
            <p class="text-gray-600 max-w-2xl mx-auto">
              Proven performance through measurable impact and consistent
              delivery across sectors.
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            <div class="bg-white p-8 rounded-lg shadow-lg hover-scale">
              <div class="stat-counter mb-2">7+</div>
              <h3 class="text-lg font-semibold text-blue-600 mb-2">
                Years of Combined
              </h3>
              <p class="text-gray-600 text-sm">Expertise</p>
            </div>

            <div class="bg-white p-8 rounded-lg shadow-lg hover-scale">
              <div class="stat-counter mb-2">100+</div>
              <h3 class="text-lg font-semibold text-blue-600 mb-2">
                Projects Executed
              </h3>
            </div>

            <div class="bg-white p-8 rounded-lg shadow-lg hover-scale">
              <div class="stat-counter mb-2">100+</div>
              <h3 class="text-lg font-semibold text-blue-600 mb-2">
                Clients Served
              </h3>
            </div>

            <div class="bg-white p-8 rounded-lg shadow-lg hover-scale">
              <div class="stat-counter mb-2">75+</div>
              <h3 class="text-lg font-semibold text-blue-600 mb-2">Field &</h3>
              <p class="text-gray-600 text-sm">Lab Equipment Units</p>
            </div>
          </div>
        </div>
      </section> */}
      <div className="w-[90%] mx-auto my-3 text-justify px-4">
        <br />

        <p className="text-md text-slate-600	 text-justify">
          To better serve your organization's needs, we kindly request the
          entire list of instruments requiring calibration. This will enable us
          to tailor our services and provide you with a competitive quotation
          promptly.
        </p>
        <br />
      </div>

      <ClientBenefits />
    </>
  );
};

export default About;

const ClientBenefits = () => {
  const benefits = [
    "Established team of well trained and qualified staff",
    "A proven client service model: locally owned and operated",
    "Considerable range of combined technical knowledge and experience",
    "Timely response to any issues",
    "Cost efficient services",
    "Fixed costs for easier budgeting",
  ];

  const sectors = [
    "Pharmaceutical Industries",
    "Hospitals",
    "Chemical Industries",
    "Fertiliser Industries",
    "Cold Storage, Cool Van",
    "Milk & Food Processing Industries",
    "Civil infrastructures"
  ];

  return (
    <div
      className="relative bg-cover bg-center text-white py-10 px-4 md:px-10"
      style={{
        backgroundImage: 'url("./img/vissonmisson.jpg")',
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60 z-0"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Benefits Section */}
          <div className="p-6 text-center bg-white bg-opacity-10 backdrop-blur-sm rounded-lg shadow-lg">
            <h2 className="text-3xl font-teko font-extrabold text-yellow-300 mb-10">
              OUR CLIENTS BENEFIT FROM
            </h2>
            {benefits.map((item, index) => (
              <p
                key={index}
                className="text-md font-semibold mb-4 flex items-start gap-3 text-left"
              >
                <FaArrowCircleRight className="text-yellow-400 mt-1" />
                {item}
              </p>
            ))}
          </div>

          {/* Sector Section */}
          <div className="p-6 text-center bg-white bg-opacity-10 backdrop-blur-sm rounded-lg shadow-lg">
            <h2 className="text-3xl font-teko font-extrabold text-yellow-300 mb-6">
              FOCUSED CLIENTS SECTOR
            </h2>
            {sectors.map((item, index) => (
              <p
                key={index}
                className="text-md font-semibold mb-4 flex items-start gap-3"
              >
                <FaArrowCircleRight className="text-yellow-400 mt-1" />
                {item}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
